import { ViewStyle, ImageStyle, TextStyle, StyleSheet } from 'react-native';
import colors from '@alucio/lux-ui/lib/theming/themes/alucio/colors';
import { DNABoxProps } from '@alucio/lux-ui/lib/components/layout/DNABox/DNABox';

export enum SLIDE_ROLL_VARIANT {
  DEFAULT,
  MEETINGS,
}

type ThumbnailStyles = Record<ThumbnailComponentStyles, ViewStyle | ImageStyle | TextStyle>;

type ThumbnailComponentStyles =
  | 'container'
  | 'innerContainer'
  | 'selected'
  | 'unselected'
  | 'pageText'
  | 'pageTextSelected'
  | 'pressableContainer'
  | 'thumbnail'

export enum ThumbnailNumberPosition {
  TOP_LEFT,
  TOP_RIGHT,
  BOTTOM_LEFT,
  BOTTOM_RIGHT,
  LEFT_TOP,
  LEFT_BOTTOM,
  RIGHT_TOP,
  RIGHT_BOTTOM,
}

export const thumbnailNumberPositionProps: Record<
  ThumbnailNumberPosition,
  Pick<DNABoxProps, 'appearance' | 'alignX' | 'alignY'>
  > = {
    [ThumbnailNumberPosition.TOP_LEFT]: {
      appearance: 'colReverse',
    },
    [ThumbnailNumberPosition.TOP_RIGHT]: {
      appearance: 'colReverse',
      // [TODO]: DNABOX NOT ADDING THE END
      alignX: 'end',
    },
    [ThumbnailNumberPosition.BOTTOM_LEFT]: {
      appearance: 'col',
    },
    [ThumbnailNumberPosition.BOTTOM_RIGHT]: {
      appearance: 'col',
      alignX: 'end',
    },
    [ThumbnailNumberPosition.LEFT_TOP]: {
      appearance: 'rowReverse',
    },
    [ThumbnailNumberPosition.LEFT_BOTTOM]: {
      appearance: 'rowReverse',
      // [TODO]: DNABOX NOT ADDING THE END
      alignY: 'end',
    },
    [ThumbnailNumberPosition.RIGHT_TOP]: {
      appearance: 'row',
    },
    [ThumbnailNumberPosition.RIGHT_BOTTOM]: {
      appearance: 'row',
      alignY: 'end',
    },
  }

interface ThumbnailSettings {
  thumbnailHeight: number,
  thumbnailWidth: number,
  numberPosition: ThumbnailNumberPosition
}

// ***  THUMBNAILS SETTINGS   *** //
// * DEFAULT THUMBNAIL SETTINGS * //
const defaultThumbnailSettings: ThumbnailSettings = {
  thumbnailHeight: 67,
  thumbnailWidth: 120,
  numberPosition: ThumbnailNumberPosition.BOTTOM_LEFT,
}

// * MEETINGS THUMBNAIL SETTINGS * //
const meetingsThumbnailSettings: ThumbnailSettings = {
  thumbnailHeight: 95,
  thumbnailWidth: 169,
  numberPosition: ThumbnailNumberPosition.BOTTOM_LEFT,
}

export const thumbnailVariantSettings: Record<SLIDE_ROLL_VARIANT, ThumbnailSettings> = {
  [SLIDE_ROLL_VARIANT.DEFAULT]: defaultThumbnailSettings,
  [SLIDE_ROLL_VARIANT.MEETINGS]: meetingsThumbnailSettings,
}

// ***  THUMBNAILS STYLES  *** //
// * DEFAULT THUMBNAIL STYLE * //
const defaultThumbnailStyles: ThumbnailStyles = {
  pressableContainer: {
    alignSelf: 'flex-start',
  },
  thumbnail: {
    // [TODO] - Check with Thai how portrait thumbnails should be handled?
    backgroundColor: colors['color-dark-1000'],
  },
  container: {
    width: thumbnailVariantSettings[SLIDE_ROLL_VARIANT.DEFAULT].thumbnailWidth + 8,
    height: thumbnailVariantSettings[SLIDE_ROLL_VARIANT.DEFAULT].thumbnailHeight + 8,
  },
  innerContainer: {
    width: thumbnailVariantSettings[SLIDE_ROLL_VARIANT.DEFAULT].thumbnailWidth + 3,
    height: thumbnailVariantSettings[SLIDE_ROLL_VARIANT.DEFAULT].thumbnailHeight + 3,
  },
  selected: {
    backgroundColor: colors['color-primary-500'],
  },
  unselected: {
    backgroundColor: colors['color-flat-500'],
  },
  pageText: {
    marginLeft: 3,
    color: colors['color-dark-1000'],
  },
  pageTextSelected: {
    color: colors['color-dark-1000'],
  },
}

// * MEETING THUMBNAIL STYLE * //
const meetingsStyle: ThumbnailStyles = {
  ...defaultThumbnailStyles,
  container: {
    backgroundColor: colors['color-dark-1000'],
    width: thumbnailVariantSettings[SLIDE_ROLL_VARIANT.MEETINGS].thumbnailWidth + 8,
    height: thumbnailVariantSettings[SLIDE_ROLL_VARIANT.MEETINGS].thumbnailHeight + 8,
  },
  innerContainer: {
    width: thumbnailVariantSettings[SLIDE_ROLL_VARIANT.MEETINGS].thumbnailWidth + 3,
    height: thumbnailVariantSettings[SLIDE_ROLL_VARIANT.MEETINGS].thumbnailHeight + 3,
  },
  selected: {
    backgroundColor: colors['color-success-500'],
  },
  pageText: {
    marginLeft: 3,
    color: colors['color-subtle-500'],
  },
  pageTextSelected: {
    color: colors['color-subtle-500'],
  },
};

export const thumbnailVariantStyles: Record<SLIDE_ROLL_VARIANT, ThumbnailStyles> = {
  [SLIDE_ROLL_VARIANT.DEFAULT]: StyleSheet.create(defaultThumbnailStyles),
  [SLIDE_ROLL_VARIANT.MEETINGS]: StyleSheet.create(meetingsStyle),
}
